import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
const navLinks = [{
  name: 'Servicios',
  href: '/servicios'
}, {
  name: 'Proceso',
  href: '/proceso'
}, {
  name: 'Enfoque',
  href: '/resultados'
}, {
  name: 'FAQ',
  href: '/faq'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/95 backdrop-blur-md transition-[padding] duration-200 ${isScrolled ? 'py-3' : 'py-4'}`} data-id="element-55" data-mp="1l1kooaol21iv">
      <div className="container mx-auto flex items-center justify-between px-6 md:px-12" data-id="element-56" data-mp="elpv11f3kliq">
        <Link to="/" className="relative z-50 inline-flex items-center text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" aria-label="Growthly, inicio" data-id="element-57" data-mp="jn6vivto65ys">
          <span className="text-[13px] font-semibold tracking-[0.16em]" data-id="element-58" data-mp="3s3ibeg5ymbrz">
            GROWTHLY
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Navegación principal" data-id="element-59" data-mp="uutka6xh6p6">
          {navLinks.map(link => {
          const isActive = location.pathname === link.href;
          return <Link key={link.href} to={link.href} aria-current={isActive ? 'page' : undefined} className={`relative px-3 py-2 text-[12px] font-medium tracking-wide transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'text-white' : 'text-neutral-400 hover:text-white'}`} data-id="element-60" data-mp="39bfssz9rclf3">
                {link.name}
                {isActive && <motion.span layoutId="nav-indicator" className="absolute inset-x-3 bottom-0 h-px bg-white" transition={{
              type: 'spring',
              stiffness: 450,
              damping: 38
            }} data-id="element-61" data-mp="3642yt49ro8e2" />}
              </Link>;
        })}
          <Link to="/contacto" className="ml-4 px-3 py-2 text-[12px] font-medium tracking-wide text-neutral-300 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-62" data-mp="2ndl8t7gbjqwe">
            Contacto
          </Link>
          <Link to="/checkout" className="ml-3 inline-flex items-center gap-2 bg-white px-4 py-2.5 text-[12px] font-semibold text-black transition-colors hover:bg-neutral-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-63" data-mp="a37le5da5iag">
            Empezar <ArrowUpRightIcon size={14} aria-hidden="true" data-id="element-64" data-mp="svjvxfe37pvo" />
          </Link>
        </nav>

        <button type="button" className="relative z-50 inline-flex h-10 w-10 items-center justify-center border border-white/15 text-white transition-colors hover:border-white/40 lg:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-white" onClick={() => setIsMobileMenuOpen(isOpen => !isOpen)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} data-id="element-65" data-mp="xud7315wj4so">
          {isMobileMenuOpen ? <XIcon size={19} data-id="element-66" data-mp="1gmpbruk12i5z" /> : <MenuIcon size={19} data-id="element-67" data-mp="3p1normkzet6l" />}
        </button>

        <AnimatePresence data-id="element-68" data-mp="3p3i5eop7zz4v">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -12
        }} transition={{
          duration: 0.22,
          ease: 'easeOut'
        }} className="absolute inset-x-0 top-0 min-h-screen bg-black px-6 pb-10 pt-28 lg:hidden" data-id="element-69" data-mp="3k2kriob8tr96">
              <nav aria-label="Navegación móvil" data-id="element-70" data-mp="1vwkuu0jow1e">
                <ul className="border-t border-white/10" data-id="element-71" data-mp="3u19z9o9fdvbp">
                  {[{
                name: 'Inicio',
                href: '/'
              }, ...navLinks, {
                name: 'Contacto',
                href: '/contacto'
              }].map(link => <li key={link.href} className="border-b border-white/10" data-id="element-72" data-mp="2d8n04zc3ntvr">
                      <Link to={link.href} aria-current={location.pathname === link.href ? 'page' : undefined} className="flex items-center justify-between py-5 text-xl font-medium tracking-tight text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-73" data-mp="2dar1pamj0gsv">
                        {link.name}
                        <ArrowUpRightIcon size={18} aria-hidden="true" data-id="element-74" data-mp="30za81km0mjib" />
                      </Link>
                    </li>)}
                </ul>
              </nav>
              <Link to="/checkout" className="mt-8 flex items-center justify-center gap-2 bg-white px-5 py-4 text-sm font-semibold text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-75" data-mp="39zfdhp7nf7tu">
                Iniciar mi proyecto{' '}
                <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-76" data-mp="19ul37h02cxf9" />
              </Link>
              <p className="mt-4 text-center text-xs text-neutral-500" data-id="element-77" data-mp="1omv8y8zu9vgz">
                Oferta única · 350€ · Sin cuotas
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}